import type { PredictionMarketMyEntry } from "@/types/PredictionMarket";
import { type AuthHeader, authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

type GetPredictionMarketMyEntriesResponse = {
  predictionMarketMyEntries: PredictionMarketMyEntry[];
};

export type GetPredictionMarketMyEntriesProps = {
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string, headers: AuthHeader) => Promise<GetPredictionMarketMyEntriesResponse>;
};

export const createDefaultGetPredictionMarketMyEntriesFetcher = () => {
  return (url: string, headers: AuthHeader) =>
    romanApi.get<GetPredictionMarketMyEntriesResponse>(url, undefined, { headers });
};

export const useGetPredictionMarketMyEntries = ({ swrOptions, fetcher }: GetPredictionMarketMyEntriesProps) => {
  const entriesFetcher = fetcher || createDefaultGetPredictionMarketMyEntriesFetcher();

  const swrQuery = useSWR(
    authHeader.get() ? "/prediction-market/my-entries" : null,
    (url: string) => entriesFetcher(url, authHeader.getOrThrow()),
    swrOptions,
  );

  return {
    myEntries: swrQuery.data?.predictionMarketMyEntries ?? [],
    ...swrQuery,
  };
};
